import * as z from "zod";

export const zoneFormSchema = z.object({
  name: z.string(),
  description: z.string().nullable().optional(),
  parent_id: z.string().nullable(),
});

export type ZoneFormSchema = z.infer<typeof zoneFormSchema>;
